<ng-template #modalSuccessExport let-c="close" let-d="dismiss">
  <wsb-modal title="{{ '' | translate }}" (dismiss)="d()" (primary)="d()" text="{{ '' | translate }}">
    <div class="d-flex" body>
      <div class="align-self-center">
        <span class="icon" [inlineSVG]="'assets/images/icons/icon-success.svg'"></span>

      </div>
      <div>
        <span [innerHtml]="'export_success1' | translate"></span>
        <span class="font-weight-bold">{{ user.profile.email }} </span>
        <span>{{ 'export_success2' | translate }}</span>
      </div>
    </div>
  </wsb-modal>
</ng-template>

<ng-template #modalExportSmsDetails let-c="close" let-d="dismiss">
  <wsb-modal
    title="{{ 'common_export_messages' | translate }}"
    (dismiss)="d()"
    cancelButtonEnable="true"
    (primary)="export()"
    primaryButtonText="sms_detail_export_export"
    text="{{ 'common_export_messages' | translate }}"
  >
    <div body>
      <span style="font-weight: bold;">Archive {{ creationDate }}</span>

      <p translate>common_export_text</p>
      <div>
        <div class="d-flex align-items-center">
          <div class="w-100">
            <label class="radio-custom">
              <input type="radio" [formControl]="fc" [value]="'XLS'" />
              <span class="radio-custom__radio"></span>
              <span class="radio-custom__label" translate>export_filetype_xls</span>
            </label>

            <label class="radio-custom">
              <input type="radio" [formControl]="fc" [value]="'XLSX'" />
              <span class="radio-custom__radio"></span>
              <span class="radio-custom__label" translate>export_filetype_xlsx</span>
            </label>

            <label class="radio-custom">
              <input type="radio" [formControl]="fc" [value]="'CSV'" />
              <span class="radio-custom__radio"></span>
              <span class="radio-custom__label" translate>export_filetype_csv</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </wsb-modal>
</ng-template>

<wsb-modal
  class="custom-modal"
  cancelButtonEnable="true"
  (close)="activeModal.close()"
  (dismiss)="activeModal.dismiss()"
  title="{{ 'reseller_history_detail_modal' | translate }}"
  [primaryButtonEnable]="!hideImport"
  (primary)="openExportModal()"
  primaryButtonText="sms_detail_export_export"
>
  <div body>
    <div class="custom-height">
      <table class="table">
        <tbody>
          <tr>
            <td class="left-column">
              <span>{{ 'common_create_time' | translate }}</span>
            </td>
            <td class="right-column">{{ creationDate }}</td>
          </tr>
          <tr>
            <td class="left-column">
              <span>{{ 'common_message' | translate }}</span>
            </td>
            <td class="right-column" translate>{{ (smsDetails?.message ? smsDetails?.message : 'encrypted_label') }}</td>
          </tr>
          <tr *ngIf="smsDetails?.sender">
            <td class="left-column">{{ 'common_sender2' | translate }}</td>
            <td class="right-column">{{ smsDetails?.sender }}</td>
          </tr>
          <tr>
            <td class="left-column">{{ 'common_message_type' | translate }}</td>
            <td class="right-column">{{ 'credit_type_' + creditType | translate }}</td>
          </tr>
          <tr>
            <td class="left-column">{{ 'common_number_recipient' | translate }}</td>
            <td class="right-column">{{ smsDetails?.recipients }}</td>
          </tr>
          <tr>
            <td class="left-column">{{ 'sms_detail_sentfrom' | translate }}</td>
            <td class="right-column">{{ smsDetails?.sentFrom }}</td>
          </tr>
          <tr>
            <!-- <td style="vertical-align: middle;" class="text-row" colspan="2">{{ message }}</td> -->
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="smsDetails?.statusCount && !lowCreditType">
      <table style="font-size: 14px;" class="table">
        <tbody>
          <tr>
            <td>
              <span style="font-weight: 600;" translate>sms_detail_statuscount_delivered</span>:
              <span>{{ getDeliveredCount()}}</span>
            </td>
            <td class="center-column">
              <span style="font-weight: 600;" translate>sms_detail_statuscount_error</span>:
              <span>{{ smsDetails?.statusCount?.error ? smsDetails.statusCount?.error.sms : 0 }}</span>
            </td>
            <td class="center-column">
              <span style="font-weight: 600;" translate>sms_detail_statuscount_waiting</span>:
              <span>{{ smsDetails?.statusCount?.waiting ? smsDetails.statusCount?.waiting.sms : 0 }}</span>
            </td>
            <td class="center-column">
              <span style="font-weight: 600;" translate>sms_detail_statuscount_timeout</span>:
              <span>{{ smsDetails?.statusCount?.timeout ? smsDetails.statusCount?.timeout.sms : 0 }}</span>
            </td>
            <td class="center-column">
              <span style="font-weight: 600;" translate>sms_detail_statuscount_blocked</span>:
              <span>{{ smsDetails?.statusCount?.blocked ? smsDetails.statusCount?.blocked.sms : 0 }}</span>
            </td>
            <td class="right-column">
              <span style="font-weight: 600;" translate>sms_detail_statuscount_blacklisted</span>:
              <span>{{ smsDetails?.statusCount?.blacklisted ? smsDetails.statusCount?.blacklisted.sms : 0 }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="max-height: 340px; overflow-y: auto;" *ngIf="!hidden">
      <wsb-atlas-grid
        #grid
        class="atlas-grid-simplest"
        class="mt-2"
        *ngIf="tableColumnsDefs && tableHistoryGridOptions"
        [loading]="tableLoading"
        [columnDefs]="tableColumnsDefs"
        [checkboxDisable]="true"
        [options]="tableHistoryGridOptions"
        [components]="components"
      ></wsb-atlas-grid>
    </div>
  </div>
</wsb-modal>
